export default __webpack_public_path__ + "static/media/pelvisSagittalMovement.513f059d.png";